var scope_0 = require('/github/workspace/packages/villa-clementine/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0610e3a126c8835c39ae4676b3d52d30.js').default;
var scope_1 = require('/github/workspace/packages/villa-clementine/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/31d0d80695d01ab89d2d7b5a60f9243e.js').default;
var scope_2 = require('/github/workspace/packages/villa-clementine/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    